// How a held-back remuneration change reads in its list (JBWEB-1468): the
// value it replaces and the one it sets, as the panel's lines word them.

const isSet = (value) => value !== undefined && value !== null && value !== '';

export const increaseLabel = (percentage) => (isSet(percentage) ? `+${String(percentage).replace('.', ',')} %` : '—');

const joined = (parts) => (parts.length ? parts.join(' · ') : '—');

export const overtimesLabel = (thresholds = []) =>
  joined(thresholds.filter((one) => isSet(one.percentage)).map((one) => `${increaseLabel(one.percentage)} au-delà de ${one.start} h`));

export const nightHoursLabel = (thresholds = []) =>
  joined(thresholds.filter((one) => isSet(one.percentage)).map((one) => `${increaseLabel(one.percentage)} de ${one.start} h à ${one.end} h`));
